module.exports = __webpack_public_path__ + "static/media/padlock.3037e497.svg";